// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".side-menu[data-v-273c7502] {\n  min-height: 100%;\n  max-width: 40vw;\n}\n.slideInLeft[data-v-273c7502] {\n  -webkit-animation: slideInLeft 0.5s;\n  /* Safari 4+ */\n  /* Fx 5+ */\n  /* Opera 12+ */\n  animation: slideInLeft 0.5s;\n  /* IE 10+, Fx 29+ */\n}\n.slideOutLeft[data-v-273c7502] {\n  -webkit-animation: slideOutLeft 0.5s;\n  /* Safari 4+ */\n  /* Fx 5+ */\n  /* Opera 12+ */\n  animation: slideOutLeft 0.5s;\n  /* IE 10+, Fx 29+ */\n}", ""]);
// Exports
module.exports = exports;
